import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import { CheckMarkStyled } from "./styles";
import colors from "core/colors";

// components
import Success from "core/ReusableIcons/Success";

const CheckMark = () => {
    const {
        state: { isReadyForDownload }
    } = useContext(AssetDownloadContext);

    if (!isReadyForDownload) {
        return null;
    }
    return (
        <CheckMarkStyled>
            <Success
                size={{ height: 20, width: 20 }}
                fillColor={colors.alternative.lightMode.chartreuse}
            />
        </CheckMarkStyled>
    );
};

export default CheckMark;
